import React, {Component} from 'react'

var Loader                  = require('react-loader');
var _                       = require('lodash');
var PostingStoreJson        = require('../../build/contracts/PostingStore.json');
var PostingStoreAddr        = PostingStoreJson.networks["4"].address;

// let MAX_RESULTS = 10;

class QueryPosting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      credentials: [],
      loadingCredentials: false,
      statusFilter: ''
    };
    this.props.web3.eth.getTransactionReceiptMined     = require('./transactionReceipt')
  }

  componentWillMount() {
  }


  async loadCredentials() {
    this.setState({loadingCredentials: true, credentials: []});
    try {
      let This = this;
      let status          = this.state.statusFilter.trim().toLowerCase();
      let credentials     = [];
      let Props           = this.props;
      let sender          = this.props.web3.eth.accounts[0];
      console.log(sender)

      this.props.postingStoreContractInstance.amountOfTokensForQuerying({gas: 500000,gasPrice: 1200000000}).then((tokens)=>{
        let tokenRequired   = tokens/1000000000000000000;
          console.log("tikenrequired: ",tokenRequired)
          this.props.echoLinkContractInstance.allowance(sender,PostingStoreAddr,{gas: 500000,gasPrice: 1200000000}).then((result)=>{
            console.log(result/1000000000000000000);
            let availableTokens   = result/1000000000000000000;
            if(availableTokens >= tokenRequired){
              Props.postingStoreContractInstance.queryPosting(status,{gas: 500000,gasPrice: 1200000000}).then((result1)=>{
                Props.web3.eth.getTransactionReceiptMined(result1.tx,10,function(txHash){
                  if(txHash.txStatus === 0){
                    This.setState({loadingCredentials: false});
                    Props.addNotification(`Transaction Exection Failed!`,"error");
                  }
                  if(txHash.txStatus === 1){
                    console.log("query posting successfully");
                      Props.postingStoreContractInstance.getPostingWhenTrue(status,{gas: 500000,gasPrice: 1200000000}).then((addressesArray)=>{
                      if(addressesArray.length !== 0){
                        Props.postingStoreContractInstance.postingSetToFalse({gas: 500000,gasPrice: 1200000000}).then((setFalse)=>{
                          Props.web3.eth.getTransactionReceiptMined(setFalse.tx,10,function(txHash){
                            if(txHash.txStatus === 0){
                              This.setState({loadingCredentials: false});
                              Props.addNotification(`Transaction Exection Failed!`,"error");
                            }
                            if(txHash.txStatus === 1){
                              console.log("Address set to false");
                              for(let i=0;i<addressesArray.length;i++){
                               credentials.push(addressesArray[i]);
                               This.setState({loadingCredentials: false, credentials: credentials});
                
                             }
                            }
                          })
                        })
                      }
                      else{
                        console.log("blank array");
                        credentials.push(0);
                        This.setState({loadingCredentials: false, credentials: credentials});
                      }
                    })
                  }
                })
              })
            }
            else if(availableTokens === 0){
              Props.echoLinkContractInstance.approve(PostingStoreAddr,tokens,{gas: 500000,gasPrice: 1200000000}).then((result)=>{
                Props.web3.eth.getTransactionReceiptMined(result.tx,10,function(txHash){
                  if(txHash.txStatus === 0){
                    This.setState({loadingCredentials: false});
                    Props.addNotification(`Transaction Exection Failed!`,"error");
                  }
                  if(txHash.txStatus === 1){
                    console.log("approved successfully");
                    Props.postingStoreContractInstance.queryPosting(status,{gas: 500000,gasPrice: 1200000000}).then((result1)=>{
                      Props.web3.eth.getTransactionReceiptMined(result1.tx,10,function(txHash){
                        if(txHash.txStatus === 0){
                          This.setState({loadingCredentials: false});
                          Props.addNotification(`Transaction Exection Failed!`,"error");
                        }
                        if(txHash.txStatus === 1){
                          console.log("query posting successfully");
                          Props.postingStoreContractInstance.getPostingWhenTrue(status,{gas: 500000,gasPrice: 1200000000}).then((addressesArray)=>{
                            if(addressesArray.length !== 0){
                              Props.postingStoreContractInstance.postingSetToFalse({gas: 500000,gasPrice: 1200000000}).then((setFalse)=>{
                                Props.web3.eth.getTransactionReceiptMined(setFalse.tx,10,function(txHash){
                                  if(txHash.txStatus === 0){
                                    This.setState({loadingCredentials: false});
                                    Props.addNotification(`Transaction Exection Failed!`,"error");
                                  }
                                  if(txHash.txStatus === 1){
                                    console.log("Address set to false");
                                    for(let i=0;i<addressesArray.length;i++){
                                      credentials.push(addressesArray[i]);
                                      This.setState({loadingCredentials: false, credentials: credentials});
                                    }
                                  }
                                })
                              })
                            }
                            else{
                              console.log("blank array");
                              credentials.push(0);
                                This.setState({loadingCredentials: false, credentials: credentials});
                            }
                          })
                        }
                      })
                    })
                  }
                })
              })
            }
            else{
              Props.echoLinkContractInstance.approve(PostingStoreAddr,0,{gas: 500000,gasPrice: 1200000000}).then((result)=>{
                Props.web3.eth.getTransactionReceiptMined(result.tx,10,function(txHash){
                  if(txHash.txStatus === 0){
                    This.setState({loadingCredentials: false});
                    Props.addNotification(`Transaction Exection Failed!`,"error");
                  }
                  if(txHash.txStatus === 1){
                    console.log("first Approve success");
                    Props.echoLinkContractInstance.approve(PostingStoreAddr,tokens,{gas: 500000,gasPrice: 1200000000}).then((results)=>{
                      Props.web3.eth.getTransactionReceiptMined(results.tx,10,function(txHash){
                        if(txHash.txStatus === 0){
                          This.setState({loadingCredentials: false});
                          Props.addNotification(`Transaction Exection Failed!`,"error");
                        }
                        if(txHash.txStatus === 1){
                          console.log("approved successfully");
                          Props.postingStoreContractInstance.queryPosting(status,{gas: 500000,gasPrice: 1200000000}).then((result1)=>{
                            Props.web3.eth.getTransactionReceiptMined(result1.tx,10,function(txHash){
                              if(txHash.txStatus === 0){
                                This.setState({loadingCredentials: false});
                                Props.addNotification(`Transaction Exection Failed!`,"error");
                              }
                              if(txHash.txStatus === 1){
                                console.log("query posting successfully");
                                Props.postingStoreContractInstance.getPostingWhenTrue(status,{gas: 500000,gasPrice: 1200000000}).then((addressesArray)=>{
                                  if(addressesArray.length !== 0){
                                    Props.postingStoreContractInstance.postingSetToFalse({gas: 500000,gasPrice: 1200000000}).then((setFalse)=>{
                                      Props.web3.eth.getTransactionReceiptMined(result.tx,10,function(txHash){
                                        if(txHash.txStatus === 0){
                                          This.setState({loadingCredentials: false});
                                          Props.addNotification(`Transaction Exection Failed!`,"error");
                                        }
                                        if(txHash.txStatus === 1){
                                          console.log("Address set to false");
                                          for(let i=0;i<addressesArray.length;i++){
                                            credentials.push(addressesArray[i]);
                                            This.setState({loadingCredentials: false, credentials: credentials});
                                          }
                                        }
                                      })
                                    })
                                  }
                                  else{
                                    console.log("blank array");
                                    credentials.push(0);
                                      This.setState({loadingCredentials: false, credentials: credentials});
                                    }
                                })
                              }
                            })
                          })
                        }
                      })
                    })
                  }
                })
              })

            }
        })
      })
      
    }
    catch (err) {
      this.setState({loadingCredentials: false});
      this.props.addNotification(err.message, "error");
    }
  }

  validForm() {
    if (!this.props.postingStoreContractInstance) {
      return false;
    }

    return this.state.statusFilter.trim();
  }

  updateInputValue(e, field) {
    this.setState({[field]: e.target.value});
  }

  obfuscate(hash) {
    return hash.substring(0, 5) + "**********" + hash.substring(hash.length - 5, hash.length);
  }
  
  renderCredential(credential){
    console.log(credential)
    if(credential === 0){
      return(<div><h3>no Match Found</h3></div>);
    }
    return(
         <li key={credential}>
          {credential}
        </li>
      );
  }

  render() {
    return (
      <div className="QueryPosting">
        <h4>Query Job Post:</h4>

        <form className="pure-form" onSubmit={(e) => event.preventDefault()}>
          <fieldset className="pure-group">
            <input type="text" className="pure-input-1-2" placeholder="Post: java,Reactjs,Nodejs,etc."
                   value={this.state.statusFilter} onChange={e => this.updateInputValue(e, 'statusFilter')}/>
          </fieldset>

          <Loader loaded={!this.state.loadingCredentials}>
            <button type="button" className="pure-button pure-input-1-2 button-success"
                    disabled={!this.validForm() || this.state.loadingCredentials}
                    onClick={() => this.loadCredentials()}>Load
            </button>
          </Loader>
        </form>

        <div>
          {this.state.credentials.map((credential) => this.renderCredential(credential))}
        </div>

      </div>
    );
  }
}

export default QueryPosting;



// WEBPACK FOOTER //
// ./src/components/QueryPosting.js